"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarForPromise = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../../utils");
var snackbar_with_close_button_1 = require("./snackbar-with-close-button");
var whiteHsla = (0, utils_1.hslToHsla)(utils_1.whiteHsl);
exports.SnackbarForPromise = (0, react_1.memo)(function (_a) {
    var isOpen = _a.isOpen, onCloseClick = _a.onCloseClick, message = _a.message, _b = _a.promiseState, promiseState = _b === void 0 ? 'success' : _b, _c = _a.position, position = _c === void 0 ? 'left' : _c;
    return (react_1.default.createElement(snackbar_with_close_button_1.BottomSnackbarWithCloseButton, { isOpen: isOpen, onCloseClick: onCloseClick, message: message, textColor: whiteHsla, backgroundColor: utils_1.snackbarColor[promiseState], position: position }));
});
exports.SnackbarForPromise.displayName = 'SnackbarForPromise';
